module.exports = __webpack_public_path__ + "0-769b4a056331d7f6ff63.worker.js"